/**
 * Hook para gerenciar as ações do input de chave NFe
 */

"use client";
import { useCallback, useState } from "react";
import { useChaveNfeCard } from "@PN/inclusao";
import { useXmlHistory } from "store";
import { useDownloadDanfe } from "./_tanstack";
import { identificacaoUtils } from "../../_utils";

export function useChaveActions() {
  const { handleManualSearch } = useChaveNfeCard();
  const { clearHistory } = useXmlHistory();
  const {
    download: downloadDanfe,
    isDownloading: isDownloadingDanfe,
    error: danfeError,
  } = useDownloadDanfe();

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [validarInclusao, setValidarInclusao] = useState(true);

  // Função para busca manual (Enter)
  const handleSearch = useCallback(
    (inputValue: string) => {
      if (!inputValue) return;

      const validation = identificacaoUtils.xml.validateKey(inputValue);
      if (validation.isValid) {
        handleManualSearch(inputValue, validarInclusao);
      }
    },
    [handleManualSearch, validarInclusao]
  );

  // Função para histórico
  const handleHistorySelect = useCallback(
    (chave: string) => {
      const chaveLimpa = identificacaoUtils.xml.cleanKey(chave);
      if (chaveLimpa) {
        handleManualSearch(chaveLimpa, validarInclusao);
      }
      setIsPopoverOpen(false);
      return chave; // Retorna a chave para ser usada no input
    },
    [handleManualSearch, validarInclusao]
  );

  // Função para limpar histórico
  const handleClearHistory = useCallback(() => {
    clearHistory();
    setIsPopoverOpen(false);
  }, [clearHistory]);

  // Função para download da DANFE
  const handleDownloadDanfe = useCallback(
    async (inputValue: string) => {
      if (!inputValue?.trim()) return;

      const chaveLimpa = identificacaoUtils.xml.cleanKey(inputValue);
      if (chaveLimpa) {
        const success = await downloadDanfe(chaveLimpa);
        if (success) {
          console.log("✅ [ChaveInput] DANFE baixada com sucesso");
        } else {
          console.error(
            "❌ [ChaveInput] Erro no download da DANFE:",
            danfeError
          );
        }
      }
    },
    [downloadDanfe, danfeError]
  );

  return {
    isPopoverOpen,
    setIsPopoverOpen,
    validarInclusao,
    setValidarInclusao,
    isDownloadingDanfe,
    danfeError,
    handleSearch,
    handleHistorySelect,
    handleClearHistory,
    handleDownloadDanfe,
  };
}
